import { render, staticRenderFns } from "./LetterData.vue?vue&type=template&id=c7db4a02&scoped=true&"
import script from "./LetterData.vue?vue&type=script&lang=js&"
export * from "./LetterData.vue?vue&type=script&lang=js&"
import style0 from "./LetterData.vue?vue&type=style&index=0&id=c7db4a02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7db4a02",
  null
  
)

export default component.exports